import { render, staticRenderFns } from "./JustificativaMassaPage.vue?vue&type=template&id=b02b0eda"
import script from "./JustificativaMassaPage.vue?vue&type=script&lang=js"
export * from "./JustificativaMassaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports